
import OfferFilter from 'tradingmate-modules/src/filters/OfferFilter'
// import { BlogModel, BlogPostStatus } from 'tradingmate-modules/src/models/api/blogs'
import { OfferCreateDto, OfferReadDto, OfferUpdateDto, OfferStatus } from 'tradingmate-modules/src/models/api/offers'
import { PagedResultSet } from 'tradingmate-modules/src/models/api/common'
import { HttpError, Services } from 'tradingmate-modules/src/services'
import { Component, Vue } from 'vue-property-decorator'
// import BlogCard from '@/components/collections/blogs/BlogCard.vue'
import OfferCard from '@/components/collections/offers/OfferCard.vue'
import Paging from '@/components/actions/Paging.vue'
import BlogType from '../../../tradingmate-modules/src/models/api/blogs/BlogType'
import BlogFilter from 'tradingmate-modules/src/filters/BlogFilter'
import { BlogModel, BlogPostStatus } from 'tradingmate-modules/src/models/api/blogs'

@Component({
  components: {
    OfferCard,
    Paging
  }
})
export default class Offers extends Vue {
  private pagedBlogs: PagedResultSet<BlogModel> | null = null
  private filter = new BlogFilter({
    Status: BlogPostStatus.Published,
    BlogType: BlogType.Offer
  })

  mounted (): void {
    this.updateFilter()
    this.getOffers()
  }

  updateFilter (): void {
    this.filter.Page = this.$route.query.page ? parseInt(this.$route.query.page.toString()) : 1
  }

  navToPage (nextPage: number): void {
    this.$router.push({ query: { page: nextPage?.toString() } })
    this.updateFilter()
    this.getOffers()
  }

  private loading = false
  private errors: HttpError | null = null;

  getOffers (): void {
    this.loading = true
    Services.API.Offers.GetOffersForPublic(this.filter)
      .then(returnData => {
        this.pagedBlogs = returnData
      }).catch((errors) => {
        this.errors = errors
      }).finally(() => {
        this.loading = false
      })
  }
}
